<template>
    <select :value="modelValue" class="form-select" :id="id" :name="name" @change="onChange($event)">
        <template v-for="(item, index) in options" :key="index">
            <template v-if="$slots.option">
                <slot name="option" :item="item" />
            </template>
            <option v-else :value="item[optionValue]" :selected="item[optionValue] == modelValue ? true : false" :disabled="item.disabled !== undefined ? item.disabled : false" :class="item.class !== undefined ? item.class : ''">
                {{ item[optionLabel] }}
            </option>
        </template>
    </select>
</template>

<script>
    export default {
        name: 'SelectC',
        props: {
            modelValue: {
                default: ""
            },
            options: {
                type: Object,
                default: () => {}
            },
            // selectedItem: {
            //     default: ""
            // },
            optionValue: {
                type: String,
                default: () => 'value'
            },
            optionLabel: {
                type: String,
                default: () => 'label'
            },
            id: {
                type: String,
                default: () => 'dropdown_id'
            },
            name: {
                type: String,
                default: () => 'dropdown_name'
            },
        },
        setup(_, {emit}) {
            const onChange = (event) => {
                emit('update:modelValue', event.target.value);
                emit('onChange', event);
            };

            return { onChange };
        },
    };
</script>